const env = process.env.REACT_APP_ENV
const redirectAfterLogin = encodeURIComponent(window.location.href)
const envConfig = {
  dev: {
    LOGIN_URL: `https://test-lmit-queuemanagement-itlm-ping-moq7sbsxma-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=${redirectAfterLogin}`,
    API_URL: 'https://gestionecode-api-test.cloud.leroymerlin.it/api/v1',
  },
  test: {
    LOGIN_URL: `https://test-lmit-queuemanagement-itlm-ping-moq7sbsxma-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=${redirectAfterLogin}`,
    API_URL: 'https://gestionecode-api-test.cloud.leroymerlin.it/api/v1',
  },
  prod: {
    LOGIN_URL: `https://prod-lmit-queuemanagement-itlm-ping-moq7sbsxma-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=${redirectAfterLogin}`,
    API_URL: 'https://gestionecode-api.cloud.leroymerlin.it/api/v1',
  },
}

export default envConfig[env]
